import React from "react";
import "../styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 Akademy. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
